import * as React from 'react';
import { cn } from '@/lib/utils';

/** Table of the mock-ups: horizontal scroll container, uppercase muted headers, light row rules. */
export function Table({ className, minWidth = 560, ...props }: React.TableHTMLAttributes<HTMLTableElement> & { minWidth?: number }) {
  return (
    <div className="overflow-x-auto">
      <table className={cn('w-full border-collapse text-sm', className)} style={{ minWidth }} {...props} />
    </div>
  );
}

export function TableHeader(props: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead {...props} />;
}

export function TableBody(props: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody {...props} />;
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return <tr className={cn('[tbody_&]:border-t [tbody_&]:border-muted', className)} {...props} />;
}

export function TableHead({ className, ...props }: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn('px-3 py-2.5 text-left text-xs font-bold uppercase tracking-[0.04em] text-muted-foreground first:pl-5 last:pr-5', className)}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cn('px-3 py-3 align-top first:pl-5 last:pr-5', className)} {...props} />;
}
